var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "mArticle" } },
    [
      _c(
        "div",
        { staticClass: "group_util" },
        [
          _vm.tab === "fandom"
            ? _c("rank-option-category", {
                on: { "reset-rank-num": _vm.resetLoadedRankNum },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("rank-option-time", {
            attrs: { date: _vm.date },
            on: { "reset-rank-num": _vm.resetLoadedRankNum },
          }),
          _vm._v(" "),
          _c("star-join-wrap"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fancafe_ranklist", attrs: { id: "fandomeTop10List" } },
        [
          _c("rank-item-wrap", {
            attrs: { itemList: _vm.rankList_top3, top3: "" },
          }),
          _vm._v(" "),
          _c("rank-item-wrap", { attrs: { itemList: _vm.rankList_3to9 } }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.tab === "fandom"
        ? _c("star-article-wrap")
        : _vm.tab === "cafe"
        ? _c("recommend-wrap")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fancafe_ranklist",
          attrs: { id: "fandomeRankListView" },
        },
        [_c("rank-item-wrap", { attrs: { itemList: _vm.rankList_rest } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fancafe_ranklist",
          attrs: { id: "fandomeMoreRankListView" },
        },
        [_c("rank-item-wrap", { attrs: { itemList: _vm.rankList_more } })],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loadedRankNum < _vm.rankList.length,
              expression: "loadedRankNum < rankList.length",
            },
          ],
          staticClass: "btn_morelist",
          attrs: { id: "btn_morelist" },
          on: { click: _vm.loadMoreRanks },
        },
        [
          _c("span", { staticClass: "ico_bestcafe ico_viewmore" }, [
            _vm._v("더 보기"),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }